

import {
    DeleteCustomerAttachmentsErrorPayLoad,
    DeleteCustomerAttachmentsRequestPayload,
    DeleteCustomerAttachmentsSuccessPayload,
    GetCustomerAttachmentsByIdErrorPayLoad,
    GetCustomerAttachmentsByIdRequestPayload,
    GetCustomerAttachmentsByIdSuccessPayload,
    GetCustomerAttachmentsErrorPayLoad,
    GetCustomerAttachmentsSuccessPayload,
    SaveCustomerAttachmentsErrorPayLoad,
    SaveCustomerAttachmentsRequestPayload,
    SaveCustomerAttachmentsSuccessPayload
} from "../interfaces/customerAttachment";

import {
    DeleteCustomerAttachmentsError,
    DeleteCustomerAttachmentsRequest,
    DeleteCustomerAttachmentsSuccess,
    GetCustomerAttachmentsByIdError,
    GetCustomerAttachmentsByIdRequest,
    GetCustomerAttachmentsByIdSuccess,
    GetCustomerAttachmentsError,
    GetCustomerAttachmentsRequest,
    GetCustomerAttachmentsSuccess,
    SaveCustomerAttachmentsError,
    SaveCustomerAttachmentsRequest,
    SaveCustomerAttachmentsSuccess,
    SetCustomerAttachmentsProps
}
    from "../types/customerAttachments/actionsTypes";

    import { Types } from "../types";

//save********************************************************************************************************************* */

export const saveCustomerAttachmentsRequestAction = (payload: SaveCustomerAttachmentsRequestPayload): SaveCustomerAttachmentsRequest => ({
    type: Types.SAVE_ATTACHMENT_REQUEST,
    payload
})

export const saveCustomerAttachmentsSuccessAction = (payload: SaveCustomerAttachmentsSuccessPayload): SaveCustomerAttachmentsSuccess => ({
    type: Types.SAVE_ATTACHMENT_SUCCESS,
    payload
})

export const saveCustomerAttachmentsErrorAction = (payload: SaveCustomerAttachmentsErrorPayLoad): SaveCustomerAttachmentsError => ({
    type: Types.SAVE_ATTACHMENT_ERROR,
    payload
})

//get************************************************************************************************************************
export const getCustomerAttachmentsRequestAction = (): GetCustomerAttachmentsRequest => ({
    type: Types.GET_ATTACHMENT_REQUEST
})

export const getCustomerAttachmentsSuccessAction = (payload: GetCustomerAttachmentsSuccessPayload): GetCustomerAttachmentsSuccess => ({
    type: Types.GET_ATTACHMENT_SUCCESS,
    payload
})

export const getCustomerAttachmentsErrorAction = (payload: GetCustomerAttachmentsErrorPayLoad): GetCustomerAttachmentsError => ({
    type: Types.GET_ATTACHMENT_ERROR,
    payload
})

//delete************************************************************************************************************************

export const deleteCustomerAttachmentsRequestAction = (payload: DeleteCustomerAttachmentsRequestPayload): DeleteCustomerAttachmentsRequest => ({
    type: Types.DELETE_ATTACHMENT_REQUEST,
    payload
})

export const deleteCustomerAttachmentsSuccessAction = (payload: DeleteCustomerAttachmentsSuccessPayload): DeleteCustomerAttachmentsSuccess => ({
    type: Types.DELETE_ATTACHMENT_SUCCESS,
    payload
})

export const deleteCustomerAttachmentsErrorAction = (payload: DeleteCustomerAttachmentsErrorPayLoad): DeleteCustomerAttachmentsError => ({
    type: Types.DELETE_ATTACHMENT_ERROR,
    payload
})

//Get By Id*************************************************************************************************************************

export const getCustomerAttachmentsByIdRequestAction = (payload: GetCustomerAttachmentsByIdRequestPayload): GetCustomerAttachmentsByIdRequest => ({
    type: Types.GET_ATTACHMENT_BY_ID_REQUEST,
    payload
})

export const getCustomerAttachmentsByIdSuccessAction = (payload: GetCustomerAttachmentsByIdSuccessPayload): GetCustomerAttachmentsByIdSuccess => ({
    type: Types.GET_ATTACHMENT_BY_ID_SUCCESS,
    payload
})

export const getCustomerAttachmentsByIdErrorAction = (payload: GetCustomerAttachmentsByIdErrorPayLoad): GetCustomerAttachmentsByIdError => ({
    type: Types.GET_ATTACHMENT_BY_ID_ERROR,
    payload
})

//reset************************************************************************************************************************
export const resetAttachmentAction = (): SetCustomerAttachmentsProps => ({
    type: Types.SET_RESET_ATTACHMENT_PROPS,
})

